// Bulk pricing for Shopify products — cart UI + checkout discount codes.
// Shopify Admin must have matching discount codes for checkout totals to match the cart.

export const ILLUSTRATED_GC_TIERS = [
  {
    minQty: 1,
    maxQty: 5,
    quantityStep: 1,
    useBasePrice: true,
    percentage: 0,
    discount: 0,
    quantityLabel: '1, 2, 3, 4, 5',
    packageLabel: 'Single copy',
    discountCode: null,
  },
  {
    minQty: 6,
    maxQty: 18,
    quantityStep: 6,
    percentage: 10,
    discount: 6.99,
    price: 63.0,
    quantityLabel: '6, 12, 18',
    packageLabel: '1-3 boxes',
    discountCode: 'PYGV5HYZ99DP',
  },
  {
    minQty: 24,
    maxQty: 48,
    quantityStep: 6,
    percentage: 15,
    discount: 10.5,
    price: 59.5,
    quantityLabel: '24, 30, 36, 42, 48',
    packageLabel: '4-8 boxes',
    discountCode: 'NM86E88JTD0N',
  },
  {
    minQty: 54,
    maxQty: 96,
    quantityStep: 6,
    percentage: 20,
    discount: 14.0,
    price: 56.0,
    quantityLabel: '54, 60, 66, 72, 78, 84, 90, 96',
    packageLabel: '9-16 boxes',
    discountCode: 'D5D5R2WN0K7J',
  },
  {
    minQty: 102,
    maxQty: Infinity,
    quantityStep: 6,
    percentage: 25,
    discount: 17.5,
    price: 52.5,
    quantityLabel: '102+',
    packageLabel: '17 or more boxes',
    discountCode: '62FEG458YTSX',
  },
];

// Lineage Colouring Books — retail 1–4 @ base price; bulk tiers per book count (box = 60)
export const COLOURING_BOOK_TIERS = [
  {
    minQty: 1,
    maxQty: 4,
    quantityStep: 1,
    useBasePrice: true,
    percentage: 0,
    discount: 0,
    quantityLabel: '1–4',
    packageLabel: 'Single copy',
    discountCode: null,
  },
  {
    minQty: 5,
    maxQty: 10,
    quantityStep: 1,
    percentage: 5,
    discount: 0.65,
    price: 12.34,
    quantityLabel: '5–10',
    packageLabel: '5–10 books',
    discountCode: process.env.GATSBY_COLOURING_BOOK_CODE_5 || null,
  },
  {
    minQty: 11,
    maxQty: 19,
    quantityStep: 1,
    percentage: 10,
    discount: 1.3,
    price: 11.69,
    quantityLabel: '11–19',
    packageLabel: '11–19 books',
    discountCode: process.env.GATSBY_COLOURING_BOOK_CODE_10 || null,
  },
  {
    minQty: 20,
    maxQty: 39,
    quantityStep: 1,
    percentage: 15,
    discount: 1.95,
    price: 11.04,
    quantityLabel: '20–39',
    packageLabel: '20–39 books',
    discountCode: process.env.GATSBY_COLOURING_BOOK_CODE_15 || null,
  },
  {
    minQty: 40,
    maxQty: 59,
    quantityStep: 1,
    percentage: 20,
    discount: 2.6,
    price: 10.39,
    quantityLabel: '40–59',
    packageLabel: '40–59 books',
    discountCode: process.env.GATSBY_COLOURING_BOOK_CODE_20 || null,
  },
  {
    minQty: 60,
    maxQty: Infinity,
    quantityStep: 1,
    percentage: 25,
    discount: 3.25,
    price: 9.74,
    quantityLabel: '60+',
    packageLabel: '1 box (60 books)',
    discountCode: process.env.GATSBY_COLOURING_BOOK_CODE_25 || null,
  },
];

// Full Colour Shareable Edition — ASI bulk tiers (replace codes in Shopify Admin when created)
export const SHAREABLE_GC_TIERS = [
  {
    minQty: 10240,
    maxQty: Infinity,
    price: 1.3,
    quantityLabel: '10,240',
    packageLabel: '8x Pallets',
    discountCode: process.env.GATSBY_SHAREABLE_GC_CODE_10240 || 'GC-SHAREABLE-10240',
  },
  {
    minQty: 5120,
    maxQty: 10239,
    price: 1.34,
    quantityLabel: '5,120',
    packageLabel: '4x Pallets',
    discountCode: process.env.GATSBY_SHAREABLE_GC_CODE_5120 || 'GC-SHAREABLE-5120',
  },
  {
    minQty: 2560,
    maxQty: 5119,
    price: 1.39,
    quantityLabel: '2,560',
    packageLabel: '2x Pallets',
    discountCode: process.env.GATSBY_SHAREABLE_GC_CODE_2560 || 'GC-SHAREABLE-2560',
  },
  {
    minQty: 1280,
    maxQty: 2559,
    price: 1.44,
    quantityLabel: '1,280',
    packageLabel: '1x Pallet',
    discountCode: process.env.GATSBY_SHAREABLE_GC_CODE_1280 || 'GC-SHAREABLE-1280',
  },
  {
    minQty: 640,
    maxQty: 1279,
    price: 1.54,
    quantityLabel: '640',
    packageLabel: 'Half Pallet',
    discountCode: process.env.GATSBY_SHAREABLE_GC_CODE_640 || 'GC-SHAREABLE-640',
  },
  {
    minQty: 128,
    maxQty: 639,
    price: 1.7,
    quantityLabel: '128',
    packageLabel: '4x Boxes',
    discountCode: process.env.GATSBY_SHAREABLE_GC_CODE_128 || 'GC-SHAREABLE-128',
  },
  {
    minQty: 64,
    maxQty: 127,
    price: 1.97,
    quantityLabel: '64',
    packageLabel: '2x Boxes',
    discountCode: process.env.GATSBY_SHAREABLE_GC_CODE_64 || 'GC-SHAREABLE-64',
  },
  {
    minQty: 32,
    maxQty: 63,
    price: 2.95,
    quantityLabel: '32',
    packageLabel: '1x Box',
    discountCode: process.env.GATSBY_SHAREABLE_GC_CODE_32 || 'GC-SHAREABLE-32',
  },
  {
    minQty: 1,
    maxQty: 31,
    useBasePrice: true,
    quantityLabel: '1–31',
    packageLabel: 'Single copies',
    discountCode: null,
  },
];

export const TIER_SCHEMES = {
  illustrated: {
    minQtyForBulk: 6,
    tiers: ILLUSTRATED_GC_TIERS,
  },
  shareable: {
    minQtyForBulk: 32,
    tiers: SHAREABLE_GC_TIERS,
  },
  colouring: {
    minQtyForBulk: 5,
    tiers: COLOURING_BOOK_TIERS,
  },
};

const SHAREABLE_GC_HANDLE = 'the-great-controversy-(full-colour-shareable-edition)';
const ILLUSTRATED_GC_HANDLE = 'the-illustrated-great-controversy';

// Separate Shopify products for bulk packages — each uses the bulk-only shipping profile.
// Set handles in Shopify Admin → Product → URL handle, or override via env.
export const SHAREABLE_GC_BULK_PRODUCT_HANDLES = {
  32: process.env.GATSBY_SHAREABLE_GC_BULK_32_HANDLE ||
    'the-great-controversy-full-colour-shareable-edition-1x-box-32-books',
  64: process.env.GATSBY_SHAREABLE_GC_BULK_64_HANDLE ||
    'the-great-controversy-full-colour-shareable-edition-2x-boxes-64-books',
  128: process.env.GATSBY_SHAREABLE_GC_BULK_128_HANDLE ||
    'the-great-controversy-full-colour-shareable-edition-4x-boxes-128-books',
  640: process.env.GATSBY_SHAREABLE_GC_BULK_640_HANDLE ||
    'the-great-controversy-full-colour-shareable-edition-half-pallet-640-books',
  1280: process.env.GATSBY_SHAREABLE_GC_BULK_1280_HANDLE ||
    'the-great-controversy-full-colour-shareable-edition-1x-pallet-1280-books',
  2560: process.env.GATSBY_SHAREABLE_GC_BULK_2560_HANDLE ||
    'the-great-controversy-full-colour-shareable-edition-2x-pallet-2560-books',
  5120: process.env.GATSBY_SHAREABLE_GC_BULK_5120_HANDLE ||
    'the-great-controversy-full-colour-shareable-edition-4x-pallets-5120-books',
  10240: process.env.GATSBY_SHAREABLE_GC_BULK_10240_HANDLE ||
    'the-great-controversy-full-colour-shareable-edition-8x-pallets-10240-books',
};

export const getShareableBulkProductHandle = (minQty) => SHAREABLE_GC_BULK_PRODUCT_HANDLES[minQty] || null;

/** Fallback title fragments — must match Shopify product titles when handle lookup fails. */
export const SHAREABLE_GC_BULK_PRODUCT_TITLE_SEARCH = {
  32: '1x Box (32 books)',
  64: '2x Boxes (64 books)',
  128: '4x Boxes (128 books)',
  640: 'Half Pallet (640 books)',
  1280: '1x Pallet (1,280 books)',
  2560: '2x Pallet (2,560 books)',
  5120: '4x Pallets (5,120 books)',
  10240: '8x Pallets (10,240 books)',
};

export const getShareableBulkProductTitleSearch = (minQty) =>
  SHAREABLE_GC_BULK_PRODUCT_TITLE_SEARCH[minQty] || null;

/** Alternate handles for common Shopify slug differences. */
export const getShareableBulkProductHandleAlternates = (minQty) => {
  const alternates = {
    1280: ['the-great-controversy-full-colour-shareable-edition-1x-pallet-1-280-books'],
    2560: ['the-great-controversy-full-colour-shareable-edition-2x-pallets-2560-books'],
    5120: ['the-great-controversy-full-colour-shareable-edition-4x-pallets-5-120-books'],
    10240: ['the-great-controversy-full-colour-shareable-edition-8x-pallets-10-240-books'],
  };

  return alternates[minQty] || [];
};

export const getShareableBulkProductHandleList = () =>
  [...new Set(Object.values(SHAREABLE_GC_BULK_PRODUCT_HANDLES).filter(Boolean))];

export const findShareableBulkProductByTitle = (products, minQty) => {
  const titleSearch = getShareableBulkProductTitleSearch(minQty);
  if (!titleSearch || !Array.isArray(products)) return null;

  return products.find((product) => product?.title?.includes(titleSearch)) || null;
};

/** Gatsby product page paths (from formatTitle on Shopify product titles) */
export const SHAREABLE_GC_PRODUCT_PATH = '/product/the-great-controversy-(full-colour-shareable-edition)';
export const ILLUSTRATED_GC_PRODUCT_PATH = '/product/the-illustrated-great-controversy';
export const SPANISH_ILLUSTRATED_GC_PRODUCT_PATH = '/product/el-conflicto-de-los-siglos-[pre-order]';

export const isColouringBookProduct = (handle, title) => {
  const normalizedTitle = (title || '').toLowerCase();
  const normalizedHandle = (handle || '').toLowerCase();

  return (
    normalizedTitle.includes('colouring book') ||
    normalizedTitle.includes('coloring book') ||
    normalizedHandle.includes('colouring-book') ||
    normalizedHandle.includes('coloring-book')
  );
};

export const getProductTierScheme = (handle, title) => {
  const normalizedTitle = (title || '').toLowerCase();
  const normalizedHandle = handle || '';

  if (
    normalizedHandle === ILLUSTRATED_GC_HANDLE ||
    (normalizedTitle.includes('illustrated') && normalizedTitle.includes('great controversy'))
  ) {
    return 'illustrated';
  }

  if (
    normalizedHandle === SHAREABLE_GC_HANDLE ||
    Object.values(SHAREABLE_GC_BULK_PRODUCT_HANDLES).includes(normalizedHandle) ||
    Object.keys(SHAREABLE_GC_BULK_PRODUCT_HANDLES).some((qty) =>
      getShareableBulkProductHandleAlternates(Number(qty)).includes(normalizedHandle)
    ) ||
    ((normalizedTitle.includes('full colour shareable') || normalizedTitle.includes('full color shareable')) &&
      normalizedTitle.includes('great controversy'))
  ) {
    return 'shareable';
  }

  if (isColouringBookProduct(normalizedHandle, title)) {
    return 'colouring';
  }

  return null;
};

const findTier = (schemeKey, quantity) => {
  const scheme = TIER_SCHEMES[schemeKey];
  if (!scheme) return null;

  const qty = parseInt(quantity, 10) || 1;
  return scheme.tiers.find((tier) => qty >= tier.minQty && qty <= tier.maxQty) || null;
};

const mapTierToPackageOption = (tier, { includeBulkHandle = false } = {}) => ({
  id: tier.useBasePrice ? 'single' : `qty-${tier.minQty}`,
  minQty: tier.minQty,
  maxQty: tier.maxQty,
  quantityStep: tier.quantityStep || 1,
  quantityLabel: tier.quantityLabel,
  packageLabel: tier.packageLabel,
  pricePerBook: tier.useBasePrice ? null : tier.price,
  percentage: tier.percentage || 0,
  useBasePrice: !!tier.useBasePrice,
  discountCode: tier.discountCode,
  bulkProductHandle: includeBulkHandle && !tier.useBasePrice ? getShareableBulkProductHandle(tier.minQty) : null,
});

export const getSteppedQuantities = (minQty, maxQty, step = 1, page = 1, pageSize = 200) => {
  const start = Math.max(1, parseInt(minQty, 10) || 1);
  const increment = Math.max(1, parseInt(step, 10) || 1);
  const currentPage = Math.max(1, parseInt(page, 10) || 1);
  const parsedMax = maxQty == null ? start : Number(maxQty);
  const hasOpenMax = maxQty != null && !Number.isFinite(parsedMax);

  if (!hasOpenMax) {
    const end = Math.max(start, Number.isFinite(parsedMax) ? parsedMax : start);
    const options = [];
    for (let qty = start; qty <= end; qty += increment) {
      options.push(qty);
    }
    return { options, hasMore: false, hasBack: false };
  }

  const pageFloor = (currentPage - 1) * pageSize + 1;
  const pageCeiling = currentPage * pageSize;
  const first =
    start + Math.max(0, Math.ceil((Math.max(start, pageFloor) - start) / increment)) * increment;
  const options = [];
  for (let qty = first; qty <= pageCeiling; qty += increment) {
    options.push(qty);
  }

  return { options, hasMore: true, hasBack: currentPage > 1 };
};

/** Cart line attribute — omit parenthetical when packageLabel already includes the quantity range. */
export const formatCartPackageAttribute = (pkg) => {
  if (!pkg) return '';

  const { packageLabel, quantityLabel, useBasePrice } = pkg;
  if (useBasePrice || !quantityLabel) return packageLabel;

  const labelLower = String(packageLabel || '').toLowerCase();
  const rangeLower = String(quantityLabel || '').toLowerCase().replace(/\+$/, '');
  if (
    rangeLower &&
    (labelLower.includes(rangeLower) ||
      (quantityLabel.includes('+') && labelLower.includes('book')))
  ) {
    return packageLabel;
  }

  return `${packageLabel} (${quantityLabel} books)`;
};

/** Display stored package attribute (including legacy redundant values). */
export const formatCartPackageDisplay = (value) => {
  if (!value) return value;

  let result = String(value).trim();
  // e.g. "1 box (60 books) (60+ books)" → "1 box (60 books)"
  result = result.replace(/^(.+\([^)]+\))\s*\([^)]+\)\s*$/i, '$1');

  const match = result.match(/^(.+?)\s*\(([^()]+)\)\s*$/i);
  if (!match) return result;

  const before = match[1].trim();
  const inside = match[2].trim().replace(/\s*books\s*$/i, '').trim();
  if (inside && before.toLowerCase().includes(inside.toLowerCase())) {
    return before;
  }

  return result;
};

export const getShareablePackageOptions = () =>
  [...SHAREABLE_GC_TIERS].sort((a, b) => a.minQty - b.minQty).map((tier) => mapTierToPackageOption(tier, { includeBulkHandle: true }));

export const getIllustratedPackageOptions = () =>
  [...ILLUSTRATED_GC_TIERS].sort((a, b) => a.minQty - b.minQty).map((tier) => mapTierToPackageOption(tier));

export const getColouringBookPackageOptions = () =>
  [...COLOURING_BOOK_TIERS].sort((a, b) => a.minQty - b.minQty).map((tier) => mapTierToPackageOption(tier));

export const getProductDisplayPrice = (priceRange) => priceRange?.minVariantPrice?.amount;

export const getShopifyPercentageDiscountedPrice = (basePrice, percentage) => {
  const priceCents = Math.round(Number(basePrice) * 100);
  const discountCents = Math.trunc((priceCents * Number(percentage)) / 100);
  return (priceCents - discountCents) / 100;
};

export const getTierPrice = (schemeKey, basePrice, quantity) => {
  if (!schemeKey || !basePrice) return basePrice;

  const tier = findTier(schemeKey, quantity);
  if (!tier) return basePrice;
  if (tier.useBasePrice) return parseFloat(basePrice);
  if (tier.percentage) {
    return getShopifyPercentageDiscountedPrice(basePrice, tier.percentage).toFixed(2);
  }

  return Number(tier.price).toFixed(2);
};

export const qualifiesForBulkDiscount = (schemeKey, quantity) => {
  const scheme = TIER_SCHEMES[schemeKey];
  if (!scheme) return false;
  return (parseInt(quantity, 10) || 0) >= scheme.minQtyForBulk;
};

export const getTierDiscountCode = (schemeKey, quantity) => {
  const tier = findTier(schemeKey, quantity);
  return tier?.discountCode || null;
};

/** @deprecated Use getTierPrice(schemeKey, basePrice, quantity) */
export const getDiscountedPrice = (basePrice, quantity, schemeKey = 'illustrated') =>
  getTierPrice(schemeKey, basePrice, quantity);

export const getShareableBookQuantityFromItem = (item) => {
  const handle = item?.handle;
  const quantity = item?.quantity || 1;

  const handleQty = Object.entries(SHAREABLE_GC_BULK_PRODUCT_HANDLES).find(([, productHandle]) => productHandle === handle);
  if (handleQty) {
    return parseInt(handleQty[0], 10) * quantity;
  }

  const alternateQty = Object.keys(SHAREABLE_GC_BULK_PRODUCT_HANDLES).find((qty) =>
    getShareableBulkProductHandleAlternates(Number(qty)).includes(handle)
  );
  if (alternateQty) {
    return parseInt(alternateQty, 10) * quantity;
  }

  const packageValue = item?.customAttr?.package || '';
  const booksMatch = packageValue.match(/([\d,]+)\s*books/i);
  if (booksMatch) {
    return parseInt(booksMatch[1].replace(/,/g, ''), 10) * quantity;
  }

  const matchingTier = SHAREABLE_GC_TIERS.find(
    (tier) => tier.packageLabel && packageValue.toLowerCase().includes(tier.packageLabel.toLowerCase())
  );
  if (matchingTier && !matchingTier.useBasePrice) {
    return matchingTier.minQty * quantity;
  }

  const title = item?.title || '';
  const titleQty = Object.entries(SHAREABLE_GC_BULK_PRODUCT_TITLE_SEARCH).find(([, search]) => title.includes(search));
  if (titleQty) {
    return parseInt(titleQty[0], 10) * quantity;
  }

  return quantity;
};

export const getAppliedCartDiscountCodes = (cartItems) => {
  const codes = [];

  const illustratedItems = cartItems.filter((item) => item.tierScheme === 'illustrated');
  if (illustratedItems.length) {
    const illustratedQty = illustratedItems.reduce((sum, item) => sum + item.quantity, 0);
    const illustratedCode = getTierDiscountCode('illustrated', illustratedQty);
    if (illustratedCode) codes.push(illustratedCode);
  }

  const colouringItems = cartItems.filter((item) => item.tierScheme === 'colouring');
  if (colouringItems.length) {
    const colouringQty = colouringItems.reduce((sum, item) => sum + item.quantity, 0);
    const colouringCode = getTierDiscountCode('colouring', colouringQty);
    if (colouringCode && !codes.includes(colouringCode)) codes.push(colouringCode);
  }

  cartItems
    .filter((item) => item.tierScheme === 'shareable')
    .forEach((item) => {
      const shareableQty = getShareableBookQuantityFromItem(item);
      const shareableCode = getTierDiscountCode('shareable', shareableQty);
      if (shareableCode && !codes.includes(shareableCode)) {
        codes.push(shareableCode);
      }
    });

  return codes;
};

export const getCartDiscountCode = (cartItems) => {
  const illustratedItems = cartItems.filter((item) => item.tierScheme === 'illustrated');
  if (illustratedItems.length) {
    const illustratedQty = illustratedItems.reduce((sum, item) => sum + item.quantity, 0);
    const illustratedCode = getTierDiscountCode('illustrated', illustratedQty);
    if (illustratedCode) return illustratedCode;
  }

  const colouringItems = cartItems.filter((item) => item.tierScheme === 'colouring');
  if (colouringItems.length) {
    const colouringQty = colouringItems.reduce((sum, item) => sum + item.quantity, 0);
    const colouringCode = getTierDiscountCode('colouring', colouringQty);
    if (colouringCode) return colouringCode;
  }

  return null;
};

export const mapLineItemsWithTierPricing = (lineItems) => {
  const tierQuantityByScheme = lineItems.reduce(
    (acc, lineItem) => {
      const scheme = getProductTierScheme(
        lineItem.merchandise?.product?.handle,
        lineItem.merchandise?.product?.title
      );
      if (scheme === 'illustrated' || scheme === 'colouring') {
        acc[scheme] = (acc[scheme] || 0) + (lineItem.quantity || 0);
      }
      return acc;
    },
    { illustrated: 0, colouring: 0 }
  );

  return lineItems.map((lineItem) => {
    const basePrice = parseFloat(lineItem.merchandise.price.amount || 0);
    const image = lineItem?.merchandise ? lineItem.merchandise.image.url : 'no images';
    const productTitle = lineItem?.merchandise?.product?.title;
    const handle = lineItem.merchandise?.product?.handle;
    const tierScheme = getProductTierScheme(handle, productTitle);
    const lineQuantity = lineItem?.quantity || 1;

    const customAttrs = lineItem.attributes
      ?.filter((attr) => !attr.key.startsWith('_'))
      .reduce((acc, attr) => {
        acc[attr.key] = attr.value;
        return acc;
      }, {});

    let price = basePrice;
    let hasDiscount = false;

    if (tierScheme === 'shareable') {
      const bookQty = getShareableBookQuantityFromItem({
        handle,
        title: productTitle,
        quantity: lineQuantity,
        customAttr: customAttrs,
      });
      const tier = findTier('shareable', bookQty);
      if (tier && !tier.useBasePrice) {
        price = (Number(tier.price) * bookQty) / lineQuantity;
        hasDiscount = price < basePrice;
      }
    } else if (tierScheme === 'illustrated' && qualifiesForBulkDiscount('illustrated', tierQuantityByScheme.illustrated)) {
      price = parseFloat(getTierPrice('illustrated', basePrice, tierQuantityByScheme.illustrated));
      hasDiscount = true;
    } else if (tierScheme === 'colouring') {
      if (qualifiesForBulkDiscount('colouring', lineQuantity)) {
        price = parseFloat(getTierPrice('colouring', basePrice, lineQuantity));
        hasDiscount = price < basePrice;
      } else {
        price = basePrice;
      }
    } else {
      const discountedPriceAttr = lineItem.attributes?.find((attr) => attr.key === '_discountedPrice');
      if (discountedPriceAttr) {
        price = parseFloat(discountedPriceAttr.value);
        hasDiscount = true;
      }
    }

    return {
      price,
      originalPrice: basePrice,
      hasDiscount,
      image,
      customAttr: customAttrs,
      id: lineItem.id,
      title: productTitle,
      handle,
      quantity: lineItem?.quantity,
      tierScheme,
      isIllustratedGC: tierScheme === 'illustrated',
    };
  });
};
